// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".special[data-v-48074116] {\n  float: right;\n  color: #e6a23c;\n  opacity: 1 !important;\n}", ""]);
// Exports
module.exports = exports;
